var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.length)?_c('section',[_c('h2',{staticClass:"accessible-hide"},[_vm._v(_vm._s(_vm.sectionTitle))]),_c(_vm.template,{tag:"component",attrs:{"data":_vm.data}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }